import { configureStore } from "@reduxjs/toolkit";
import AuthenticationReducer from "../slices/Authentication";

const store = configureStore({
  reducer: {
    // reducers
    AuthenticationReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
